// Defines main application routes

import { routes } from "./routes";

//Pages
import SamplePage from "../pages/pages/SamplePage";
import Error404 from "../components/pages/others/errorPage/Error404";
import UsersPage from "../pages/UsersPage";
import UserRegisterPage from "../pages/pages/UserRegisterPage";
import UserUpdatePage from "../pages/UserUpdatePage";
import UpdatePasswordPage from "../pages/UpdatePasswordPage";
import DistributaryZoneListPage from "../pages/DistributaryZoneListPage";
import DistributaryZoneFormPage from "../pages/DistributaryZoneForm";
import UpdateDistrbutoryZonepage from "../pages/UpdateDistrbutoryZonepage";
import SchemeVillagePage from "../pages/SchemeVillagePage";
import UpdateSchemeVillagePage from "../pages/UpdateSchemeVillagepage";
import AddSchemeVillagePage from "../pages/AddSchemeVillagePage";

import ChackPage from "../pages/ChackPage";
import UpdateChackPage from "../pages/UpdateChackPage";
import ChackInstrumentPage from "../pages/ChackInstrumentPage";
import UpdateChackInstrumentPage from "../pages/UpdateChackInstrumentPage";
import AddChackPage from "../pages/pages/AddChackPage";
import AddChackInstrumentDetailPage from "../pages/AddChackInstrument";
import EmailPage from "../pages/EmailPage";
import UpdateEmailPage from "../pages/UpdateEmail";
import AddEmailPage from "../pages/AddEmailPage";
import ChackValveDetailPage from "../pages/ChackValveDetailPage";
import UpdateChackValveDetailPage from "../pages/UpdateChackValveDetailPage";
import AddChackValveDetailPage from "../pages/AddChackValveDetailPage"; 
import KhasaraPage from "../pages/KhasaraPage";
import UpdateKhasarPage from "../pages/UpdateKhasar";
import AddKhasarPage from "../pages/AddKhasar";
import UserProfilePage from "../pages/UserProfilePage";
import FarmerPage from "../pages/FarmerPage";
import KmlPage from "../pages/KmlPage";
import UpdateKmlPage from "../pages/UpdateKmlPage";
import AddKmlPage from "../pages/AddKmlPage";

import MapViewPage from "../pages/MapViewPage";
import MapView from "../components/mapView/MapView";
import KmLLayer from "../components/mapView/KmlLayer";
import ChackComponent from "../components/mapView/ChackComponent";
import ProjectSettingsPage from "../pages/ProjectSettingsPage";
import UpdateProjectPage from "../pages/UpdateProjectPage";
import AddProjectPage from "../pages/AddProjectPage";
import OmsListPage from "../pages/OmsListPage";
import UpdateOmsPage from "../pages/UpdateOmsPage";
import AddOmsPage from "../pages/AddOmsPage";
import Dashboard from "../pages/DashboardPage";
import CheckEmail from "../auth/ForgotPassword";
import EmailSenderPage from "../pages/EmailSenderPage";

import Report from "../components/reports/Report";

import AlarmsTablePage from "../pages/AlarmsTablePage";
import UpdateFarmerPage from "../pages/UpdateFarmerPage";
import AddFarmerPage from "../pages/pages/AddFarmerPages";
import BeneficiaryList from "../components/configuration/beneficiarylist/BeneficiaryList";
import AddBeneficiary from "../components/configuration/beneficiarylist/AddBeneficiary";
import UpdateBeneficiary from "../components/configuration/beneficiarylist/UpdateBeneficiary";
import PumpingStation from "../components/PumpingStation/PumpingStation";
import AddPumpingStation from "../components/PumpingStation/AddPumpingStation";
import UpdatePumpingStation from "../components/PumpingStation/UpdatePumpingStation";
import AddPumpinghStationPage from "../pages/AddPumpingStationPage";
import UpdatePumpingStationPage from "../pages/UpdatePumpingStationPage";
import UpdatePumpingStationHistory from "../components/PumpingStation/UpdatePumpingStationHistory";
import AddPumpingStationHistoryPage from "../pages/AddPumpingStationHistoryPage";
import TrendsPage from "../pages/TrendsPage";
import GetReportPumpingStationPage from "../pages/GetReportPumpingStationPage";
import PowerConsumptionAddPage from "../pages/PowerConsumptionAddPage";
import PowerConsumptionPage from "../pages/PowerConsumptionPage";
import PowerConsumptionUpdate from "../components/PowerConsumption/PowerConsumptionUpdate";
import UpdatePowerConsumptionPage from "../pages/UpdatePowerConsumptionPage";
import Group from "../components/Group/Group";
import AddGroup from "../components/Group/AddGroup";
import UpdateGroup from "../components/Group/UpdateGroup";
import AddChakInGroup from "../components/ScheduleKusumi/AddChakInGroup";
import ViewEditChakFromGroup from "../components/ScheduleKusumi/ViewEditChakFromGroup";
import GroupScheduler from "../components/ScheduleKusumi/GroupScheduler";
import ScheduleStatus from "../components/ScheduleKusumi/ScheduleStatus";
import WuaList from "../components/configuration/Wua/WuaList";
import AddWua from "../components/configuration/Wua/AddWua";
import UpdateWua from "../components/configuration/Wua/UpdateWua";



export const AppRoutes = [
  
  //Pages
  { path: routes.Sample, element: <SamplePage /> },
  { path: routes.Users, element: <UsersPage /> },
  { path: routes.UserRegister, element: <UserRegisterPage /> },
  { path: routes.UpdateUser, element: <UserUpdatePage /> },
  { path: routes.UpdatePassword, element: <UpdatePasswordPage /> },
   {path: routes.UserProfilePage, element: <UserProfilePage/> },
  { path: routes.DistributaryZoneForm, element: <DistributaryZoneFormPage /> },
  { path: routes.DistributaryZoneList, element: <DistributaryZoneListPage /> },
  { path: routes.DistributaryZoneUpdate, element: <UpdateDistrbutoryZonepage /> },
  
  { path: routes.SchemeVillageList, element: <SchemeVillagePage /> },
  { path: routes.SchemeVillageUpdate, element: <UpdateSchemeVillagePage /> },
  { path: routes.SchemeVillageAdd, element: <AddSchemeVillagePage /> },
  { path: routes.ChackList, element: <ChackPage /> },
  { path: routes.ChackUpdate, element: <UpdateChackPage /> },
  { path: routes.ChackInstrument, element: <ChackInstrumentPage /> },
  { path: routes.ChackInstrumentUpdate, element: <UpdateChackInstrumentPage /> },
  { path: routes.ChackAdd, element: <AddChackPage /> },
  { path: routes.AddChackInstrument, element: <AddChackInstrumentDetailPage /> },
  { path: routes.EmailList, element: <EmailPage /> },
  { path: routes.EmailUpdate, element: <UpdateEmailPage /> },
  { path: routes.AddEmail, element: <AddEmailPage /> },
  { path: routes.ChackValveDetail, element: <ChackValveDetailPage /> },
  { path: routes.UpdateChackValveDetail, element: <UpdateChackValveDetailPage /> },
  { path: routes.AddChackValveDetail, element: <AddChackValveDetailPage /> },
  { path: routes.KhasaraList, element: <KhasaraPage /> },
  { path: routes.KhasaraUpdate, element: <UpdateKhasarPage /> },
  { path: routes.AddKhasara, element: <AddKhasarPage /> },
  {path:routes.FarmerList, element: <FarmerPage/>},
  {path:routes.FarmerUpdateL, element:<UpdateFarmerPage/>},
  {path:routes.AddFarmer, element:<AddFarmerPage/>},
  {path:routes.KmlList,element:<KmlPage/>},
  {path:routes.AddKml, element:<AddKmlPage/>},
  {path:routes.UpdateKml, element:<UpdateKmlPage/>},
  {path : routes.MapView, element:<MapViewPage/>},
  //project
  {path:routes.ProjectList,element:<ProjectSettingsPage/>},
  {path:routes.ProjectUpdate,element:<UpdateProjectPage/>},
  {path:routes.ProjectAdd,element:<AddProjectPage/>},
  {path:routes.OmsList,element:<OmsListPage/>},
  {path:routes.OmsUpdate,element:<UpdateOmsPage/>},
  {path:routes.OmsAdd,element:<AddOmsPage/>},
  {path:routes.DashBoard,element:<Dashboard/>},
  {path:routes.EmailSender,element:<EmailSenderPage/>},
  //mqtt
  
 // {path:routes.PopUp,element:<ChackComponent/>}
   // report 
   {path:routes.report,element:<Report/>},

   //
  
   {path:routes.Alarms,element:<AlarmsTablePage/>},
   {path:routes.BeneficiaryList,element:<BeneficiaryList/>},
   {path:routes.BeneficiaryAdd,element:<AddBeneficiary/>},
   {path:routes.BeneficiaryUpdate,element:<UpdateBeneficiary/>},

   {path:routes.PumpingStationList,element :<PumpingStation/>},
   {path:routes.PumpingStaionAdd,element:<AddPumpinghStationPage/>},
    {path:routes.PumpingStationUpdate,element:<UpdatePumpingStationPage/>},

    {path:routes.UpdatePumpingStationHistory,element:<UpdatePumpingStationHistory/>},
    {path:routes.AddPumpingStationHistory,element:<AddPumpingStationHistoryPage/>},
    {path:routes.Trends, element:<TrendsPage/>},
    {path:routes.GetReportPumpingStation,element:<GetReportPumpingStationPage/>},
    {path:routes.PowerConsuumption, element:<PowerConsumptionPage/>},
    {path:routes.AddPowerConsumption, element:<PowerConsumptionAddPage/>},
    {path:routes.UpdatePowerConsumption,element:<UpdatePowerConsumptionPage/>},
    {path:routes.Group,element:<Group/>},
    {path:routes.AddGroup,element:<AddGroup/>},
    {path:routes.UpdateGroup,element:<UpdateGroup/>},
    {path:routes.AddChakInGroup,element:<AddChakInGroup/>},
    {path:routes.ViewEditChak,element:<ViewEditChakFromGroup/>},
    {path:routes.GroupScheduler,element:<GroupScheduler/>},
    {path:routes.ScheduleStatus,element:<ScheduleStatus/>},
    {path:routes.WuaList,element:<WuaList/>},
    {path:routes.AddWua,element:<AddWua/>},
    {path:routes.WuaUpdate,element:<UpdateWua/>}

];

export const AuthRoutes = [

  // Error Pages
  { path: routes.ErrorPages.Error404, element: <Error404 /> },
  
];
